<template>
  <div class="offcanvas-footer border-top">
    <div class="d-grid d-md-flex gap-3 p-3">
      <button class="btn btn-primary d-flex align-items-center gap-1" type="submit" id="save-button">
        Save
        <i class="icon-disk"></i>
      </button>      
      <button class="btn btn-soft-primary d-flex align-items-center gap-1" type="button" data-bs-dismiss="offcanvas">
        Cancel
        <i class="icon-Arrow---Right-2"></i>
      </button>
    </div>
  </div>
</template>